const addTruncate = (text, limit = 9) => {
  if (text.length > limit) {
    return text.slice(0, limit).concat('...');
  }
  return text;
};

export { addTruncate };
